export default class PageNavigation {
    constructor($element) {
        this.$element = $element;
        this.offsets = [];

        this.calculateOffsets();
        this.setActive($(window).scrollTop());
        this.bindEvents();
    }


    bindEvents() {
        let me = this;
        this.$element.on('click', '.js-page-navigation-link', function () {
            me.scrollTo($(this).attr('href'));
            return false;
        });

        $(window).on('scroll', () => {
            let scrollTop = $(window).scrollTop();
            me.setActive(scrollTop);
        });

        $(window).on('resize', () => {
            me.calculateOffsets();
        });
    }

    setActive(scrollTop) {
        let active = '';

        this.offsets.forEach((value, index) => {
            if ((index - 70) <= scrollTop) {
                active = value;
            }
        });

        this.$element.find('.js-page-navigation-link').removeClass('page-navigation__link--active');
        this.$element.find('.js-page-navigation-link[href="' + active + '"]').addClass('page-navigation__link--active');
    }

    calculateOffsets() {
        let me = this;
        this.offsets = [];

        this.$element.find('.js-page-navigation-link').each(function () {
            let id = $(this).attr('href');
            let offset = Math.round($(id).offset().top);
            me.offsets[offset] = id;
        });
    }

    scrollTo(id) {
        let scrollTop = $(id).offset().top;
        $('html, body').animate({scrollTop: scrollTop - 70}, 300);
    }
}